import {
  Box,
} from '@chakra-ui/react';
import {
  IconPerson,
  IconEmail,
  IconTelephone,
  IconOnline,
  IconFamily,
  IconChildren,
  IconAdult,
  IconAdolescents,
  IconCouple,
  IconGroup,
  IconCompany,
} from '../../../styles/icons';

export const showIcon = (icon) => {
  const iconFormat = (icon) => <Box paddingRight="4px">{icon}</Box>;

  switch (icon) {
    case 'email':
      return iconFormat(<IconEmail height="16px" width="16px" />);
    case 'online':
      return iconFormat(<IconOnline height="16px" width="16px" />);
    case 'phone':
      return iconFormat(<IconTelephone height="16px" width="16px" />);
    case 'person':
      return iconFormat(<IconPerson height="16px" width="16px" />);
    case 'family':
      return iconFormat(<IconFamily height="20px" width="20px" />);
    case 'adult':
      return iconFormat(<IconAdult height="20px" width="20px" />);
    case 'adolescents':
      return iconFormat(<IconAdolescents height="20px" width="20px" />);
    case 'couple':
      return iconFormat(<IconCouple height="20px" width="20px" />);
    case 'children':
      return iconFormat(<IconChildren height="20px" width="20px" />);
    case 'group':
      return iconFormat(<IconGroup height="20px" width="20px" />);
    case 'company':
      return iconFormat(<IconCompany height="20px" width="20px" />);

    default:
      return null;
  }
};
